import React from "react";
import Svg, { G, Path, Circle } from "react-native-svg";

const ActionStreakBadge = ({ size }) => {
  return (
    <Svg width={size} height={size} viewBox="0 0 145 145">
      <G
        id="badges"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <G id="1-copy-116" transform="translate(-116.000000, -240.000000)">
          <G
            id="Group-4"
            transform="translate(119.000000, 243.000000)"
            fill="#F35F5F"
            stroke="#FFE66D"
            strokeWidth="6"
          >
            <Circle id="Oval" cx="69.5" cy="69.5" r="69.5"></Circle>
          </G>
          <G
            id="burning"
            transform="translate(150.000000, 265.000000)"
            fillRule="nonzero"
          >
            <Path
              d="M68.2923274,33.2060401 C68.2923274,36.3310401 66.8078067,36.9570604 64.9771164,36.9570604 C63.1464261,36.9570604 61.6619052,36.3310401 61.6619052,33.2060401 C61.6619052,30.0803114 63.1464261,26.0210179 64.9771164,26.0210179 C66.8078067,26.0210179 68.2923274,30.0803114 68.2923274,33.2060401 Z"
              id="Path"
              fill="#FFDC13"
            ></Path>
            <Path
              d="M64.9771164,26.0210179 C64.574831,26.0210179 64.1893075,26.2170593 63.8322062,26.555941 C65.0995511,27.7598823 66.0032358,30.7675489 66.0032358,33.2060401 C66.0032358,35.6445313 65.0995511,36.561334 63.8322062,36.8470149 C64.1893075,36.9271806 64.574831,36.9570604 64.9771164,36.9570604 C66.8078067,36.9570604 68.2923274,36.3310401 68.2923274,33.2060401 C68.2923274,30.0803114 66.8078067,26.0210179 64.9771164,26.0210179 L64.9771164,26.0210179 Z"
              id="Path"
              fill="#FFAA00"
            ></Path>
            <Path
              d="M72.0513642,65.2460354 C72.0513642,82.0698752 58.4130131,95.7089552 41.5884444,95.7089552 C24.7638759,95.7089552 11.1247959,82.0698752 11.1247959,65.2460354 C11.1247959,44.1202192 28.2292153,43.4198636 28.2292153,23.5016325 C28.2292153,9.88587332 35.7625933,2.99017612 39.5150711,0.399370336 C40.3385903,-0.169076493 41.4543493,0.472976866 41.3836578,1.47067388 C40.9638817,7.39636772 40.5892899,22.6438608 47.8348006,22.6438608 C62.1909981,22.6438608 46.7846315,46.4544951 62.1909981,46.4544951 C70.3467526,46.4544951 72.0513642,59.8742129 72.0513642,65.2460354 Z"
              id="Path"
              fill="#FFDC13"
            ></Path>
            <Path
              d="M62.1909981,46.4544951 C46.7846315,46.4544951 62.1909981,22.6438608 47.8348006,22.6438608 C40.5900187,22.6438608 40.9646104,7.39636772 41.3836578,1.4714028 C41.4543493,0.472976866 40.339319,-0.169076493 39.5150711,0.400099067 C37.9547575,1.47723302 35.7407299,3.29917799 33.6863049,6.03938321 C33.5237873,12.9977554 34.2671409,23.5978312 40.3079815,23.5978312 C54.6641791,23.5978312 39.2578125,47.4084655 54.6641791,47.4084655 C62.8199336,47.4084655 64.5245451,60.8281832 64.5245451,66.2000058 C64.5245451,80.4017024 54.8055619,92.3339843 41.6562209,95.7082265 C58.4494519,95.6717875 72.0513642,82.0472832 72.0513642,65.2460354 C72.0513642,59.8742129 70.3467526,46.4544951 62.1909981,46.4544951 Z"
              id="Path"
              fill="#FFAA00"
            ></Path>
            <Path
              d="M48.9046466,61.3667502 C42.4877565,61.3667502 42.0475746,49.4082323 42.3223239,42.5562616 C42.4024896,40.546292 40.0463504,39.4042968 38.523933,40.719741 C34.6001924,44.1085588 29.2983325,50.8016558 29.2983325,62.2237931 C29.2983325,73.821566 23.5009037,78.9047925 18.6559877,85.2969041 C24.2398845,91.6780841 32.4430095,95.7089552 41.5884444,95.7089552 C50.7353369,95.7089552 58.9406483,91.6758978 64.5245451,85.2925315 C64.1208022,85.2181961 63.7002974,85.1773845 63.2601155,85.1773845 C47.8537489,85.1773845 63.2601155,61.3667502 48.9046466,61.3667502 Z"
              id="Path"
              fill="#FFAA00"
            ></Path>
            <Path
              d="M58.7147272,84.0944205 C54.6095207,89.7402634 48.6138642,93.9227203 41.6562209,95.7082265 C50.7768772,95.6878207 58.9544951,91.6605935 64.5245451,85.2925315 C64.1208022,85.2181961 63.7002974,85.1773845 63.2601155,85.1773845 C61.2771104,85.1773845 59.8057078,84.7816582 58.7147272,84.0944205 L58.7147272,84.0944205 Z"
              id="Path"
              fill="#FF8500"
            ></Path>
            <Path
              d="M41.5884444,95.7089552 C45.7490381,95.7089552 49.714319,94.8737757 53.3268715,93.3637478 C51.1040987,88.1704757 55.7624476,77.7482218 47.3931612,77.7482218 C43.9015858,77.7482218 42.689628,73.1860716 42.3500175,68.6253789 C42.0636078,64.7672284 36.9760086,63.5647446 35.051306,66.9193097 C33.4203007,69.7608151 32.1719041,73.5307836 32.1719041,78.4143248 C32.1719041,84.8093517 29.9003032,88.6529269 27.2366196,92.1211812 C31.5138175,94.4102728 36.3988164,95.7089552 41.5884444,95.7089552 L41.5884444,95.7089552 Z"
              id="Path"
              fill="#FF8500"
            ></Path>
            <Path
              d="M41.6562209,95.7082265 C45.7920358,95.6994812 49.7339961,94.8657591 53.3276004,93.3637478 C52.9449918,92.4709946 52.7664412,91.4244694 52.6899196,90.3028802 C49.4643481,92.7996735 45.7249884,94.6638877 41.6562209,95.7082265 L41.6562209,95.7082265 Z"
              id="Path"
              fill="#FF6D00"
            ></Path>
            <Path
              d="M74.9176481,19.4846082 C74.9176481,21.067514 73.6342701,22.350892 72.0513642,22.350892 C70.4691873,22.350892 69.1858093,21.067514 69.1858093,19.4846082 C69.1858093,17.9024312 70.4691873,15.2839319 72.0513642,15.2839319 C73.6342701,15.2839319 74.9176481,17.9024312 74.9176481,19.4846082 Z"
              id="Path"
              fill="#FFDC13"
            ></Path>
            <Path
              d="M5.73111007,54.3471606 C5.73111007,55.9293377 4.44846082,57.2127157 2.86555504,57.2127157 C1.28337799,57.2127157 0,55.9293377 0,54.3471606 C0,52.7642549 1.28337799,50.1457556 2.86555504,50.1457556 C4.44846082,50.1457556 5.73111007,52.7642549 5.73111007,54.3471606 L5.73111007,54.3471606 Z"
              id="Path"
              fill="#FFDC13"
            ></Path>
            <G
              id="Group"
              transform="translate(1.679104, 15.111940)"
              fill="#FFAA00"
            >
              <Path
                d="M70.3722597,0.171991604 C69.9583138,0.171991604 69.564045,0.352728545 69.2091302,0.646426119 C70.2111998,1.47358918 70.9108267,3.20443675 70.9108267,4.37266791 C70.9108267,5.54089907 70.2111998,6.54369757 69.2091302,6.99043843 C69.5647739,7.14858321 69.9575851,7.23895168 70.3722597,7.23895168 C71.9551657,7.23895168 73.2378149,5.95557369 73.2378149,4.37266791 C73.2385437,2.79049086 71.9551657,0.171991604 70.3722597,0.171991604 Z"
                id="Path"
              ></Path>
              <Path
                d="M1.18645056,35.0338153 C0.772504664,35.0338153 0.378235821,35.2145522 0.0233208955,35.5082498 C1.02539067,36.3354127 1.72501754,38.0669892 1.72501754,39.2352203 C1.72501754,40.4027228 1.02539067,41.4055213 0.0233208955,41.8522621 C0.378964552,42.0104069 0.771775933,42.1007754 1.18645056,42.1007754 C2.76935634,42.1007754 4.0520056,40.8173974 4.0520056,39.2352203 C4.0520056,37.6523146 2.76935634,35.0338153 1.18645056,35.0338153 Z"
                id="Path"
              ></Path>
              <Path
                d="M60.435372,20.4531541 C61.0103778,21.5652694 62.07658,21.8451201 63.2980119,21.8451201 C64.5194438,21.8451201 65.5856459,21.5659981 66.1606519,20.4531541 C66.1278567,18.8986707 64.8597832,17.6488164 63.2980119,17.6488164 C61.7362407,17.6488164 60.468167,18.8986707 60.435372,20.4531541 Z"
                id="Path"
              ></Path>
            </G>
            <Path
              d="M65.9995918,32.9516966 C66.0017782,33.0369636 66.0032358,33.1222306 66.0032358,33.2060401 C66.0032358,35.642345 65.1010086,36.5598765 63.83585,36.8462862 C64.1914937,36.9257229 64.5762884,36.9570604 64.9771164,36.9570604 C66.1985483,36.9570604 67.2647504,36.6779384 67.8397563,35.5650944 C67.8142491,34.3698985 67.0577776,33.3568972 65.9995918,32.9516966 Z"
              id="Path"
              fill="#FF8500"
            ></Path>
          </G>
        </G>
      </G>
    </Svg>
  );
};

ActionStreakBadge.defaultProps = {
  size: 145,
};

export default ActionStreakBadge;
